<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates29">
<p class="centerImage"><img alt="images" id="plate29" src="images/plate29.jpg"/></p>
<p class="caption">More smiles for the camera chaps. Left to right: unknown, Wickham, D Wheeler, RWF, Dennis Monger, unknown, Ian Taylor, George Farries and Harold Leonard.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates29.vue?cd745214